// Product related endpoints
export const productEndpoints = (builder) => ({
  getProductsByType: builder.query({
    query: ({ insurerId, productType }) => ({
      url: '/common/get-products-by-type',
      method: 'GET',
      params: { insurerId, productType },
    }),
    providesTags: ['Product'],
  }),
});
